import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { GLOBAL } from './global.service';
import { AddUsers } from '../models/adduser/adduser/adduser.module';

@Injectable({
  providedIn: 'root'
})
export class AddUsersService {
  public url: string;
  public users:AddUsers;
  constructor(public _http: HttpClient) { 
    this.url = GLOBAL.url;
  }

  getUsers(user, token): Observable<any>{
    let json = JSON.stringify(user);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'equipo', params, {headers: headers});
  }

  addUser(user,token): Observable<any>{
    let json = JSON.stringify(user);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'add_users_equipo', params, {headers: headers});
 }
 delUser(user,token): Observable<any>{
    let json = JSON.stringify(user);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'del_users_equipo', params, {headers: headers});
  }
  addCliente(user,token): Observable<any>{
    let json = JSON.stringify(user);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'add_cliente_equipo', params, {headers: headers});
  }
  registerCliente(user,token): Observable<any>{
    let json = JSON.stringify(user);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'register_cliente_equipo', params, {headers: headers});
  }
  delCliente(user,token): Observable<any>{
    let json = JSON.stringify(user);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'del_cliente_equipo', params, {headers: headers});
  }

  change_image(edit,file,token): Observable<any>{
     //let json = JSON.stringify(edit);
     //let params = 'json='+ json;
     //let headers = new HttpHeaders().set('Content-Type', 'multipart/form-data').set('Accept', 'application/json').set('Authorization', token);
    // return this._http.post(this.url + 'change_image', params, { headers: headers});
    var myFormData = new FormData();
    let headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    headers.append('Authorization', token);
    myFormData.append('image', file);
    myFormData.append('id', edit.id);
    myFormData.append('token', token);
    return this._http.post(this.url + 'change_image', myFormData, { headers: headers,  reportProgress: true, observe: 'events' });
  }
  subir_archivos(file): Observable<any>{
   var myFormData = new FormData();
   let headers = new HttpHeaders();
   headers.append('Content-Type', 'multipart/form-data');
   headers.append('Accept', 'application/json');
   myFormData.append('file', file);
   return this._http.post(this.url + 'subir_archivo', myFormData, { headers: headers,  reportProgress: true, observe: 'events' });
 }
  editInfo(user,token): Observable<any>{
    let json = JSON.stringify(user);
    let params = 'json='+json;
    let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                     .set('Authorization', token);
    return this._http.post(this.url + 'change_info', params, {headers: headers});
 }
 editPass(user,token): Observable<any>{
  let json = JSON.stringify(user);
  let params = 'json='+json;
  let headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
                   .set('Authorization', token);
  return this._http.post(this.url + 'change_pass', params, {headers: headers});
}

}
